import React from "react";
import PropTypes from "prop-types";
import { renderSingleWithLabel } from "../../../../common/helpers/helpers";
import PublicationLinks from "../../../../components/Publications/components/PublicationLinks";
import Expander from "../../../../components/Expander";
import TextExpander from "../../../../components/TextExpander";
import withErrorGuard from "../../../../HOC/withErrorGuard";
import JaxCkbGeneContent from "./JaxCkbGeneContent";
import JaxCkbContent from "./JaxCkbContent";
import LinkifyBase from "../../../../components/social/LinkifyBase";
import ComponentPanel from "../../../../components/atoms/ComponentPanel/ComponentPanel";
import JaxCkbClinicalTrialsContent from "./JaxCKBClinicalTrials/JaxCkbClinicalTrialsContent";

const JaxCkbGeneComponent = (props) => {
  const { data } = props;
  if (data && Object.keys(data || {}).length > 0) {
    const {
      version,
      gene_role: geneRole,
      gene_descriptions,
      curation_policy_info: curationPolicyInfo,
      evidence,
      clinical_trials: clinicalTrials,
    } = data;
    const content = (
      <div className="varsome-inner-container">
        <div className="varsome-horiz-flex">
          {geneRole && (
            <React.Fragment>
              <h6>Gene role</h6>
              {renderSingleWithLabel(geneRole, "description", "Description")}
              {geneRole.pub_med_references && (
                <div className="varsome-horiz-list-item">
                  <div className="varsome-horiz-list-label">Publications</div>
                  <div className="varsome-horiz-list-value">
                    {geneRole.pub_med_references.length > 0 ? (
                      <PublicationLinks
                        limit={10}
                        ids={geneRole.pub_med_references}
                      />
                    ) : (
                      "-"
                    )}
                  </div>
                </div>
              )}
            </React.Fragment>
          )}
        </div>
        <div className="tw-mt-8">
          <h6>Gene descriptions</h6>
          <table className="varsome-table">
            <thead>
              <tr>
                <th width="20%">Publications</th>
                <th width="80%">Description</th>
              </tr>
            </thead>
            <Expander showMore="4" component="tbody">
              {Array.isArray(gene_descriptions) &&
                gene_descriptions.map((description, i) => {
                  return (
                    <tr key={i}>
                      <td>
                        {description.pub_med_references ? (
                          <PublicationLinks
                            limit={10}
                            ids={description.pub_med_references}
                          />
                        ) : (
                          "-"
                        )}
                      </td>
                      <td>
                        <TextExpander
                          text={description.description}
                          truncate="300"
                        />
                      </td>
                    </tr>
                  );
                })}
            </Expander>
          </table>
          {curationPolicyInfo?.amino_acid_ranges?.length && (
            <div className="tw-mt-2">
              <h6>Curation Policy</h6>
              {curationPolicyInfo?.curation_policy && (
                <p className="tw-mt-2">
                  <LinkifyBase txt={curationPolicyInfo?.curation_policy} />
                </p>
              )}
              <JaxCkbGeneContent items={curationPolicyInfo.amino_acid_ranges} />
            </div>
          )}
          {evidence && evidence.length && (
            <div className="tw-mt-8">
              <h6>Evidence Results</h6>
              <JaxCkbContent evidenceType="evidence" items={evidence} />
            </div>
          )}
          {clinicalTrials && clinicalTrials.length && (
            <div className="tw-mt-8">
              <h6>Clinical Trials</h6>
              <JaxCkbClinicalTrialsContent clinicalTrials={clinicalTrials} />
            </div>
          )}
          <div className="varsome-text-muted" style={{ marginTop: "2rem" }}>
            <small>
              <i>
                Somatic gene variant annotations and related content have been
                powered by The Jackson Laboratory Clinical Knowledgebase
                (JAX-CKB™).
              </i>
            </small>
          </div>
        </div>
      </div>
    );
    return (
      <div
        className="varsome-result-fixed"
        id="jax-ckb123"
        data-testid="jax-ckb-gene-component"
      >
        <div className="varsome-container varsome-container__basic">
          <ComponentPanel
            version={version}
            url="https://ckb.jax.org/"
            content={content}
            title="JAX CKB"
          />
        </div>
      </div>
    );
  }
  return null;
};

JaxCkbGeneComponent.propTypes = {
  data: PropTypes.shape({
    version: PropTypes.string,
    gene_descriptions: PropTypes.arrayOf(PropTypes.shape({})),
    gene_role: PropTypes.shape({
      description: PropTypes.string,
      pub_med_references: PropTypes.arrayOf(PropTypes.number),
    }),
    curation_policy_info: PropTypes.shape({
      curation_policy: PropTypes.string,
      amino_acid_ranges: PropTypes.arrayOf(PropTypes.number),
    }),
    evidence: PropTypes.arrayOf(
      PropTypes.shape({
        pub_med_references: PropTypes.arrayOf(PropTypes.number),
        therapy_id: PropTypes.number,
        therapy: PropTypes.string,
        response_type: PropTypes.string,
        normalized_drug: PropTypes.string,
        approval_status: PropTypes.string,
        amp_tier: PropTypes.string,
        normalized_cancer: PropTypes.string,
        cap_asco_evidence_level: PropTypes.string,
        indication: PropTypes.string,
        efficacy_evidence: PropTypes.string,
        evidence_type: PropTypes.string,
      })
    ),
    clinical_trials: PropTypes.arrayOf(
      PropTypes.shape({
        nctid: PropTypes.string,
        phase: PropTypes.string,
        recruitment: PropTypes.string,
        title: PropTypes.string,
      })
    ),
  }),
};

JaxCkbGeneComponent.defaultProps = {
  data: null,
};

export default withErrorGuard(
  JaxCkbGeneComponent,
  "JaxCkbGeneComponent",
  "JAX CKB"
);
